export function formatBumpChartData(data) {
    var valuesByDay = {};
    data.forEach(function(dataItem, index) {
        dataItem.data.forEach(function(param) {
            var x = param.x, y = param.y;
            if (valuesByDay[x] === undefined) {
                valuesByDay[x] = [];
            }
            valuesByDay[x].push({
                index: index,
                value: y
            });
        });
    });
    Object.keys(valuesByDay).forEach(function(day, dayIndex) {
        var valuesArr = valuesByDay[day];
        valuesArr.sort(function(a, b) {
            return a.value - b.value;
        });
        var previousValue;
        var positionIndex = 0;
        for(var i = 0; i < valuesArr.length; i++){
            var _valuesArr_i = valuesArr[i], dataIndex = _valuesArr_i.index, value = _valuesArr_i.value;
            if (value !== previousValue) {
                positionIndex++;
            }
            previousValue = value;
            data[dataIndex].data[dayIndex].y = positionIndex;
        }
    });
    return data;
}
